<template>
  <p
    v-if="viewer"
    class="ls-chip"
    data-test="ls-viewer-chip"
  >
    <span class="ls-chip__who">{{ label }}</span>
    <button
      v-if="tracked"
      type="button"
      class="ls-chip__action"
      data-test="ls-viewer-not-me"
      @click="$emit('not-me')"
    >Not you?</button>
    <button
      v-else
      type="button"
      class="ls-chip__action"
      data-test="ls-viewer-change"
      @click="$emit('change')"
    >Change</button>
  </p>
</template>

<script>
/**
 * Who the buyer's likes and notes go out as (KP-4572). An email link
 * visitor can say "Not you?" so a forwarded link never speaks for the
 * retailer it was sent to; a self-identified visitor can change what they typed.
 */
export default {
  name: 'LsViewerChip',
  props: {
    viewer: { type: Object, default: null },
  },
  computed: {
    tracked() {
      return this.viewer.via === 'email_link'
    },
    label() {
      const name = this.viewer.store_name || (this.tracked ? '' : this.viewer.email)
      return name ? `Commenting as ${name}` : 'Commenting from your email link'
    },
  },
}
</script>

<style lang="scss" scoped>
@import './ls-base';

.ls-chip {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  min-width: 0;
  max-width: 100%;
  margin: 0;
  color: var(--ls-muted);
  font: 400 0.8125rem/1.3 var(--ls-body-font);

  &__who {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  &__action {
    flex: none;
    min-height: 44px;
    padding: 0 6px;
    border: 0;
    background: transparent;
    color: var(--ls-ink);
    font: 600 0.8125rem/1 var(--ls-body-font);
    text-decoration: underline;
    text-underline-offset: 3px;
    cursor: pointer;
    touch-action: manipulation;
    @include ls-focus;
  }
}
</style>
